import { ApplicationRef, ComponentRef, createComponent, Injectable } from "@angular/core";
import { ToastComponent } from "@storeblocks/toast-ng";

export interface Toast {
  visible: boolean;
  options?: ToastOptions;
}

export interface ToastOptions {
  variant?: "error" | "info" | "success" | "warning" | "neutral";
  duration?: "short" | "medium" | "long" | "always";
  title?: string;
  text?: string;
}

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private activeToast?: ComponentRef<ToastComponent>;

  constructor(private readonly appRef: ApplicationRef) {}

  public show(options?: ToastOptions): void {
    // Destroy any existing toast
    if (this.activeToast) {
      this.hide();
    }

    this.activeToast = createComponent(ToastComponent, {
      environmentInjector: this.appRef.injector,
    });

    this.activeToast.instance.rebrand = true;
    this.activeToast.instance.text = options?.text || "";
    this.activeToast.instance.title = options?.title || "";
    this.activeToast.instance.duration = options?.duration || "short";
    this.activeToast.instance.variant = options?.variant || "info";

    this.appRef.attachView(this.activeToast.hostView);
    const domElement = (this.activeToast.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElement);
  }

  public hide(): void {
    if (this.activeToast) {
      this.appRef.detachView(this.activeToast.hostView);
      this.activeToast.destroy();
      this.activeToast = undefined;
    }
  }
}
